<template>
  <div id="account_activity">
    <change-password ref='changePassComponent'/>
    <otp-modal name="otp_modal" :submit="updateModeWhitelist" :params="getParamsUpdateModeWhitelist()" :is-disable-button="isDisableButton" :contact_email="siteSetting.contact_email"/>
    <cancel-google-auth-modal @CancelGoogleAuthModal:CLOSE="hideCancelGoogleAuthModal"></cancel-google-auth-modal>
    <enable-google-authentication @EnableGoogleAuthentication:CLOSE="hideEnableGoogleAuthenticaion"></enable-google-authentication>
    <lost-otp-modal :contact_email="siteSetting.contact_email" name="lostOtpForm" @DISABLE_OTP_SUCCESS="disableOtpSuccess"/>
    <confirmation-modal>
      <template slot="content">
        <div class="checkbox-bank">
          <input type="checkbox" id="c-bank" v-model="isCreateNewBankAccount"/>
          <label for="c-bank">{{ $t('refferal.confirm_bank_account_content') }}</label>
        </div>
      </template>
    </confirmation-modal>
        <div class="right_list_option_acc">
          <div class="setting_top_header">
            <AccountTopHeader :title="$t('account.security')" />
          </div>
          <div class="contents_setting">
            <div class="title_back">
             
              <img :src="`/images/icon/icon-left${theme === 'light-theme' ? '' : '-dark'}.svg`" alt="icon" class="icon_back" @click="clickBack">
              <span class="title-medium-small">{{ $t('account.last_login')}}</span>
            </div>
            <div class="acount_info">
              <div class="path_last_login">
                <div class="datatable">
                  <data-table :getData="getHistoryConnection" :widthTable="'100%'" :classHeader="'header-css'" id="table-device" ref="datatable" class=" table_min">
                    <th class="text-left cl_date">{{$t('account.date')}}</th>
                    <th class="text-right">{{$t('account.ip_address')}}</th>
                    <template slot="body" slot-scope="props">
                      <tr class="last-login" :class="{ white: ((props.index + 1) % 2 === 0), gray: ((props.index + 1) % 2 !== 0) }">
                        <td class="text-left">{{ props.item.created_at | timestampToDate}}</td>
                        <td class="text-right">{{ props.item.ip_address }}</td>
                      </tr>
                    </template>
                  </data-table>
                </div>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
  import rf from '@/request/RequestFactory'
  import RemoveErrorsMixin from '@/common/RemoveErrorsMixin';
  import CancelGoogleAuthModal from '@/components/shared_components/otp/CancelGoogleAuthModal';
  import OtpModal from '@/components/shared_components/funds/common/OtpModal';
  import EnableGoogleAuthentication from './account/EnableGoogleAuthentication';
  import ChangePassword from './account/ChangePassword.vue';
  import DeviceManager from './account/DeviceManager.vue';
  import LostOtpModal from '@/components/shared_components/otp/LostOtpModal';
  import ConfirmationModal from '@/components/shared_components/common/ConfirmationModal';
  import SelectBox from '@/components/shared_components/common/SelectBox';
  import moment from 'moment';
  import Const from '@/common/Const';
  import { getLayoutPath } from '@/routes';
  import ChartContracts from "./ChartIndex.vue";
  import { mapState } from 'vuex';
  import AccountSiteBar from '@/components/shared_components/common/AccountSiteBar.vue';
  import AccountTopHeader from '@/components/shared_components/common/AccountTopHeader.vue';

  import 'url-search-params-polyfill';
  import Cookies from 'js-cookie'
  const KYC_UNVERIFED = 'unverified';
  const KYC_PENDING = 'pending';
  const KYC_VERIFIED = 'verified';
  const KYC_REJECTED = 'rejected';
  const BANK_UNVERIFED = 'unverified';
  const BANK_CREATING = 'creating';
  const BANK_VERIFING = 'verifing';
  const BANK_VERIFIED = 'verified';
  const BANK_REJECTED = 'rejected';
  var sha1 = require('sha1');
  export default {
    components: {
      ChartContracts,
      CancelGoogleAuthModal,
      EnableGoogleAuthentication,
      OtpModal,
      ChangePassword,
      LostOtpModal,
      DeviceManager,
      ConfirmationModal,
      SelectBox,
      AccountSiteBar,
      AccountTopHeader
    },
    mixins: [RemoveErrorsMixin],
    data() {
      return {
        linkKycAccount: getLayoutPath({name: 'IdentityPersonal'}, true),
        linkAPIAccount: getLayoutPath({name: 'ApiCreated'}, true),
        linkAPIPage: process.env.VUE_APP_API_URL + '/api/documentation',
        isShowTooltip: false,
        tab : 'main',
        enableWhiteList: undefined,
        enableLeaderboard: undefined,
        localShowFakeName: undefined,
        lastLogin: {},
        withdrawalLimitBTC: [],
        check: 0,
        settings: {
          email: true,
          phone: false,
          bank: false,
          otp: false,
          password: false,
        },
        kyc: {
          status: '',
          bank_status: '',
        },
        user: {},
        infomation: {},
        otp: undefined,
        userSettingWhitelist: undefined,
        enableOtp: true,
        emailNotification: true,
        telegramNotification: true,
        lineNotification:false,
        isCreateNewBankAccount: false,
        enableAmalFromAdmin: false,
        enableAmlPay: false,
        app_name : process.env.VUE_APP_NAME,
        moment: moment,
        isDisableButton: false,
        siteSetting: {},
        idEncrypt:'',
        perpetual_dividend: false,
        isEditFakeName: false,
        fakeNameTemp:'',
        theme: Cookies.get("user-theme", { domain: process.env.VUE_APP_PUBLIC_URL }) || 'dark-theme',
      }
    },
    watch: {
      enableAmalFromAdmin(newValue) {
        if (!newValue) {
          this.enableAmlPay = false;
        }
      }
    },
    mounted(){
      this.getMasterData();
      let url=window.location.href;
      if(url.includes("need-close")) {
          window.close();
      }
    },
    computed: {
      ...mapState({
        masterdata: state => state.masterdata,
        userThemeMode: (state) => state.userThemeMode,
      }),
      isVerifiableBank() {
        return this.kyc.bank_status === BANK_CREATING
                || this.kyc.bank_status === BANK_VERIFING || this.kyc.bank_status === BANK_VERIFIED;
      },
      appUrl() {
        return window.location.origin;
      },
      submittableKyc() {
        return window._.get(this, "user.security_setting.otp_verified", 0);
      },
      userSecurityLevel() {
        if (this.user.security_level > this.user.max_security_level) {
          return this.user.security_level;
        }
        return this.user.max_security_level;
      }  
    },
    methods: {
        onSaveFakeName(){
          rf.getRequest('UserRequest').onUpdateFakeName({fake_name: this.fakeNameTemp}).then(res =>{
            if(res && res.data){
             this.user.fake_name = this.fakeNameTemp;
             this.isEditFakeName = false;
             this.getUser(false);
             this.showSuccess(this.$t('mam.update.success'));
            }
          })
        },
        activeLeaderboard() {
        },
        getLinkPnlChart() {
          rf.getRequest('UserRequest').getLinkPnlChart({name: 'Pnl-Chart'}).then(res => {
              const path = APP_URL + '/pnl-chart?token='+res.data.id
              // if (!navigator.clipboard) {
              //   Utils.fallbackCopyTextToClipboard(path);
              //   return;
              // }
              // navigator.clipboard.writeText(path);
              // this.$router.push({ name: 'PNLChart', query: {token: res.data.id} });
              window.open(path,"_blank");
          });
        },
        convertDate(date) {
          var dateFormat = 'YYYY-MM-DD HH:mm:ss';
          var testDateUtc = moment.utc(date);
          var localDate = testDateUtc.local();
          return localDate.format(dateFormat);
        },  
        addChannelTelegram: function (userID) {
          document.getElementById("cancel_focus_telegram").blur();
          this.listenForTelegramLine(userID);
          let apiTelegram = process.env.VUE_APP_MIX_API_TELEGRAM + userID;    
          window.open(apiTelegram, "_blank");
        },

        getParamsUpdateModeWhitelist() {
          return {
            active: !this.userSettingWhitelist
          }
        },
        listenForTelegramLine(userId) {      
            window.Echo.private('App.User.' + userId)
              .listen('UserNotificationUpdated', (res) => { 
                    let channel = res.data.channel;
                    let is_enable= res.data.is_enable;
                    if(channel==="line"){
                      this.lineNotification = is_enable;
                    }
                    if(channel==="mail"){
                      this.emailNotification = is_enable;
                    }
                    if(channel==="telegram"){
                      this.telegramNotification = is_enable;
                    }
              });
        },
        async redirectLine(userID){          
            await this.encryptId();            
            document.getElementById("cancel_focus_line").blur();
            if(userID){
              let callback_uri=this.$router.resolve({name: 'Account'}).href+"?need-close";
              let state = userID + "&" + this.idEncrypt + "$" + callback_uri;
              let client_id=process.env.VUE_APP_MIX_LINE_CLIENT_ID;
              let redirect_uri=process.env.VUE_APP_API_URL+'/api/v1/get-auth-code';
              let response_type = "code";
              let url="https://notify-bot.line.me/oauth/authorize?";
              let scope="notify";
              var searchParams = new URLSearchParams("");
              searchParams.append("client_id",client_id);
              searchParams.append("redirect_uri",redirect_uri);
              searchParams.append("response_type",response_type);
              searchParams.append("scope",scope);
              searchParams.append("state",state);
              url=url+searchParams;              
              window.open(url,"_blank");
            }
        },
        changeWalletFee(type) {
          if (this.tab != type && this.enableAmlPay) {
            this.tab = type;
            let param = {
              wallet_name : type,
            }
            rf.getRequest('UserRequest').changeTypeWalletAmalPayFee(param).then(res => {});
          }
          
        },
        
        showChannelModal(type, channel) {            
            if (type === 'disable') {
                window.ConfirmationModal.show({
                    type: channel === 'email' ? 'disableEmail' : channel === 'telegram' ? 'disableTelegram' : channel==='line' ? 'disableLine':'',
                    title: '',
                    content: channel === 'email' ?
                        this.$t('account.email_disable_confirm') :
                        channel === 'telegram' ? this.$t('account.email_disable_confirm') : 
                        channel === 'line' ? this.$t('account.email_disable_confirm') : '',
                    btnCancelLabel: window.i18n.t('common.action.no'),
                    btnConfirmLabel: window.i18n.t('common.action.yes'),
                    onConfirm: () => {
                        this.actionNotification(type, channel);
                    }
                });
            } else {
                document.getElementById("cancel_focus_mail").blur();
                this.actionNotification(type, channel);
            }
        },
      actionNotification(type, channel) {
            let param = {
                active: 1
            };
            if (type === 'disable') {
                param.active = 0;
            } else {
                param.active = 1;
            }
            if (channel === 'email') {
                rf.getRequest('UserRequest').changeEmailNotification(param).then(res => {
                    this.getUserNotification();
                });
            }
            if (channel === 'telegram' && param.active == 0) {
                rf.getRequest('UserRequest').changeTelegramNotification(param).then(res => {
                    this.getUserNotification();
                });
            }
            if (channel === 'line' ) {
                rf.getRequest('UserRequest').changeLineNotification(param).then(res => {
                    this.getUserNotification();
                });
            }
        },
      showTooltip() {
        this.isShowTooltip = !this.isShowTooltip;
      },
      hideTooltip() {
        this.isShowTooltip = false;
      },
      showCancelGoogleAuthModal() {
        window.CommonModal.show('CancelGoogleAuthModal');
      },
      showChangePasswordModal() {
        window.CommonModal.show('ChangePassword');
        this.$refs.changePassComponent.resetData();
      },
      hideCancelGoogleAuthModal() {
        window.CommonModal.hide('CancelGoogleAuthModal');
        this.getSecuritySettings();
        this.getUser(false);
      },
      hideEnableGoogleAuthenticaion() {
        window.CommonModal.hide('EnableGoogleAuthentication');
        this.getSecuritySettings();
        this.getUser(false);
      },
      showEnableOtpModal() {
        window.CommonModal.show('EnableGoogleAuthentication');
      },
      showModalLostOtp () {
        window.CommonModal.show('lostOtpForm');
      },
      disableOtpSuccess () {
        this.getSecuritySettings();
        this.getUser(false);
      },
      loadDataImmediately() {
        this.getUserSettings();
        this.getUserNotification();
        this.getSecuritySettings();
        this.getUser();
        this.getWithdrawalLimitBTC();
        this.getUserKyc();     
        this.getDividendSettings();   
      },
      getSecuritySettings() {
        rf.getRequest('UserRequest').getSecuritySettings().then(res => {
          this.settings = Object.assign({}, this.settings, res.data);
          this.enableOtp = window._.get(this, "settings.otp_verified", 0);
        });
      },
      getUserKyc() {
        rf.getRequest('UserRequest').getUserKyc().then(res => {
          this.kyc = res.data || {};
          this.isCreateNewBankAccount = this.kyc.bank_status === BANK_CREATING;
        });
      },
      async encryptId() {
        await rf.getRequest('UserRequest').encryptId().then(res => {
          this.idEncrypt = sha1(res.toString()) || {};          
        });                
      },
      getDividendSettings() {
        rf.getRequest('UserRequest').getDividendSetting().then(res => {
          this.enableAmalFromAdmin = res.data?.enable_fee_amal || false;
          this.perpetual_dividend = res.data?.enable_wallet_pay_fee || false;
        })

      },
      getHistoryConnection(params) {
        const promise = rf.getRequest('UserRequest').getHistoryConnection(params);
        this.getLatest(promise);
        return promise;
      },
      getLatest(promise) {
        promise.then(res => {
          this.lastLogin = res.data.data[0];
        });
      },

      getUserNotification(){
        rf.getRequest('UserRequest').getUserNotificationSettings().then(res => {
            const emailNotification =  _.find(res.data, (item) => {
              return item.channel === 'mail'
            }) || {};

            this.emailNotification = emailNotification.is_enable === 1;

            const telegramNotification = _.find(res.data, (item) => {
              return item.channel === 'telegram'
            }) || {};

            this.telegramNotification = telegramNotification.is_enable === 1;

            const lineNotification = _.find(res.data, (item) => {
              return item.channel === 'line'
            }) || {};
            this.lineNotification = lineNotification.is_enable === 1;
        });
      },

      getUserSettings() {
        rf.getRequest('UserRequest').getUserSettings().then(res => {
          const setting = _.find(res.data, (item) => {
            return item.key === 'whitelist'
          }) || {};
          this.userSettingWhitelist = this.enableWhiteList = !!parseInt(setting.value);

          const amlPay =  _.find(res.data, (item) => {
            return item.key === 'amal_pay'
          }) || {};
          const amlWalletPay =  _.find(res.data, (item) => {
            return item.key === 'amal_pay_wallet'
          }) || {};
          this.enableAmlPay = amlPay.value === "1";
          if (amlWalletPay && amlWalletPay.value) {
            this.tab = amlWalletPay.value;
          }

        });
      },
      getUser(useCache = true) {        
        rf.getRequest('UserRequest').getCurrentUser(useCache).then(res => {
          this.user = Object.assign({}, this.user, res.data);
          this.listenForTelegramLine(res.data.id);
          this.localShowFakeName = this.user.security_setting.use_fake_name;
          return this.enableLeaderboard = this.user.security_setting.use_fake_name
        });
      },
      getWithdrawalLimitBTC() {
        rf.getRequest('UserRequest').getWithdrawalLimitBTC().then(res => {
            this.withdrawalLimitBTC = res.data;
        });
      },
      activeWhitelist() {
        const message = this.userSettingWhitelist ? window.i18n.t('account.turn_on_mode_whitelist') : window.i18n.t('account.turn_off_mode_whitelist');
        this.showModal({
          type: 'primary',
          title: '',
          content: message,
          onConfirm: () => {
            if (this.enableOtp) {
              window.CommonModal.show('otp_modal');
              this.enableWhiteList = this.userSettingWhitelist;
            } else {
              const params = this.getParamsUpdateModeWhitelist();
              this.updateModeWhitelist(params);
            }
          },
          onCancel: () => {
            this.enableWhiteList = this.userSettingWhitelist;
          }
        });
      },
      updateModeWhitelist(params) {
        this.isDisableButton = true;
        rf.getRequest('UserRequest').activeWhitelist(params).then( response => {
          this.isDisableButton = false;
          window.CommonModal.hide('otp_modal');
          this.userSettingWhitelist = this.enableWhiteList = response.data.whitelist;
        }).catch(error => {
          this.isDisableButton = false;
          if (!error.response) {
            Message.error(window.i18n.t('common.message.network_error'));
          } else {
            this.convertRemoteErrors(error);
          }
        })
      },
      activeLeaderboard() {
        const message = this.enableLeaderboard ? window.i18n.t('leaderboard.show_fake_username') : window.i18n.t('leaderboard.show_real_username');
        this.showModal({
          title: '',
          content: message,
          btnCancelLabel: window.i18n.t('common.action.no'),
          btnConfirmLabel: window.i18n.t('common.action.yes'),
          onConfirm: () => {
            this.updateLeaderboard()
          },
          onCancel: () => {
            this.enableLeaderboard = !this.enableLeaderboard ? 1 : 0
          }
        });
      },
      updateLeaderboard() {
        let params = {
          use_fake_name: !this.enableLeaderboard ? 0 : 1
        }
        rf.getRequest('UserRequest').activeLeaderBoard(params).then(res=>{
          this.localShowFakeName = res.data;
        }).catch(err=>{
          this.localShowFakeName = 0;
        });
      },
      showSuccess(message) {
        Message.success(
          message,
          {},
          { position: 'bottom_left' }
        );
      },
      getSocketEventHandlers() {
        return {
          OtpUpdated: this.getSecuritySettings
        }
      },
      verifyBankAccount (status) {
        rf.getRequest('UserRequest').updateBankAccountStatus(status).then(res => {
          this.getUserKyc();
        });
      },
      verifyBankModal () {
        if (this.kyc.status !== KYC_VERIFIED) {
          this.showModal({
            type: 'warning',
            title: 'Error',
            content: this.$t('refferal.alert_bank_account_content'),
            noAction: true,
          });
          return;
        }
        this.showModal({
          type: 'confirm',
          title: this.$t('refferal.confirm_bank_account_title'),
          customContent: true,
          onConfirm: () => {
            this.verifyBankAccount({status: this.isCreateNewBankAccount ? BANK_CREATING : BANK_VERIFING})
          }
        });
      },
      showModal (config) {
        const type = config.type;
        const title = config.title;
        const content = config.content;
        const customContent = config.customContent;
        let btnCancelLabel = config.btnCancelLabel || this.$t('common.action.no');
        let btnConfirmLabel = config.btnConfirmLabel || this.$t('common.action.yes');
        if (config.noAction) {
          btnCancelLabel = null;
          btnConfirmLabel = null;
        }
        const onConfirm = config.onConfirm;
        const onCancel = config.onCancel;
        window.ConfirmationModal.show({
          type: type,
          title: title,
          content: content,
          customContent: customContent,
          btnCancelLabel: btnCancelLabel,
          btnConfirmLabel: btnConfirmLabel,
          onConfirm: onConfirm,
          onCancel: onCancel
        });
      },
      onClickedVerifyGoogleAuthen(pathRoute) {
        if (!this.submittableKyc) {
          Message.error(this.$t('account.otp.should_enable_first'), {}, { position: 'bottom_left' });
          return;
        }
        this.$router.push({ path: pathRoute });
      },
      activeAmlPay() {
        if (this.enableAmalFromAdmin) {
          let param = {
            active: !this.enableAmlPay ? 1 : 0
          }
          rf.getRequest('UserRequest').changeAmlPay(param).then(res => { });
        }
      },
      getUserDevice(params) {
        const promise = rf.getRequest('UserRequest').getUserDevice(params);
        return promise;
      },
      onDatatableFinished() {
        if (!this.$refs.datatableDevice || !this.$refs.datatableDevice.rows) {
          return;
        }
        window._.each(this.$refs.datatableDevice.rows, item => {
          item.isActiveRow = false;
        });
      },
      activeRow(item) {
        item.isActiveRow = !item.isActiveRow;
        this.$forceUpdate();
      },
      refreshDevice() {
        this.$refs.datatableDevice.refresh();
      },
      confirmRemoveDevice (deviceId) {
        window.ConfirmationModal.show({
          type: 'primary',
          title: '',
          content: this.$t('account.modal.confirm_trusted_device'),
          btnCancelLabel: window.i18n.t('common.action.no'),
          btnConfirmLabel: window.i18n.t('common.action.yes'),
          onConfirm: () => {
            this.removeDevice(deviceId);
          },
          onCancel: () => {
            
          }
        });
      },
      removeDevice (deviceId) {
        rf.getRequest('UserRequest').deleteDevice(deviceId).then((res) => {
          this.refreshDevice();
          Message.success(window.i18n.t('address.deleted_success'));
        });
      },

      getMasterData() {
        window._.each(this.masterdata.settings, item => {
          this.siteSetting[item.key] = item.value;
        });
      },
      clickBack() {
        this.$router.back();
      }
    },
    created () {
      this.loadDataImmediately();      
        document.title = this.$t('menu.account') + ` – ${this.tabTitle}`;
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/variables";
  .title-medium-small {
    color: var(--dark-1);
    font-family: $font-inter-bold;
    font-size: 34px;
    line-height: 36px;
    text-transform: none;
  }
  .path_acount_container {
    display: flex;
    padding-top: 4px;
    gap: 4px;
    background-color: var(--color-black);
  }
  .right_list_option_acc{
    background-color: var(--background-color-primary);
    flex: 1;
    .contents_setting {
      max-width: 1360px;
      padding: 40px 40px 120px 40px;
      .title_back {
        display: flex;
        gap: 18px;
        align-items: center;
        margin-bottom: 70px;
        .icon_back {
          cursor: pointer;
          height: 16px;
        }
      }
    }
    
  }
  @media screen and (max-width: 992px) {
    .title-medium-small {
      font-size: 20px;
      line-height: 24px;
    }
    .right_list_option_acc {
      .contents_setting {
        padding: 30px 15px;

        .title_back {
          margin-bottom: 30px;
          .icon_back {
            height: 14px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {}
  @media screen and (max-width: 576px) {}
</style>

<style lang="scss">
#account_activity {

  .VuePagination {
    background-color: transparent;
    .pagination {
      justify-content: center;
    }
  }

  .tableContainer{
    table{
      th{
        color: var(--text-close);
        font-weight: 400;
        background: var(--color-tab-data-table);
        font-size: 18px;
        line-height: 22px;

        &:hover{
          color: var(--text-close) !important;
        }
      }
      td{
        color: var(--text-primary-color);

        &:last-child{
          padding-right: 15px !important;
        }
      }
    }
  }

}
@media screen and (max-width: 992px) {
  #account_activity {
    .tableContainer {
      table {
        th {
          font-size: 14px;
          line-height: 16px;
          padding: 17px 15px;
        }
        td {
          font-size: 14px;
          line-height: 16px;
          padding: 17px 15px;
        }
      }
    }
  }    
}
@media screen and (max-width: 992px) {
  #account_activity {
    .tableContainer {
      table{
        th, td{
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>